import React, { useEffect, useState } from "react";
import Layout from "../../layout";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import Services from "../../API/services";
import moment from "moment";
import { Margin, usePDF } from "react-to-pdf";
import { useLocation } from "react-router-dom";
import { showPrice, showRowPrice, StringToJSON } from "utils/utils";

const FoodInvoiceBill = ({booking, allOrders}) => {

  // const { state } = useLocation();
  // let { item, booking, allOrders } = state;
  let item = [...allOrders]

  const [textInputs, setTextInputs] = useState({
    billNumber: "",
    name: "",
    gst: "",
  });
  const { userDetail } = useSelector(authenticationSeletor);
  const [propertyData, setPropertyData] = useState({});

  let totalGst = 0;
  let netAmt = 0;
  allOrders?.forEach((item) =>
    {
      let orderItem = StringToJSON(item?.orderItems)
      orderItem?.forEach((order) => {
        totalGst = totalGst + order?.taxAmount;
        netAmt = netAmt + order?.totalAmount;
      })
    }
  );
  const cgstVal = totalGst / 2;
  const sgstVal = totalGst / 2;

  const totalAmount = allOrders.reduce((acc, curr)=> acc + curr.orderAmount, 0)
  const gstAmount = (totalAmount * 12) / 100;
  const totalGrossAmount = totalAmount / (1 + (12 / 100))

  const { toPDF, targetRef } = usePDF({
    method: "open",
    filename: "roomInvoice.pdf",
    page: {
      margin: Margin.SMALL,
      format: "A6",
    },
    canvas: {
      mimeType: "image/png",
      qualityRatio: 1,
    },
  });

  useEffect(() => {
    getPropertyDetail();
  }, []);

  const getPropertyDetail = async () => {
    try {
      const res = await Services.property.getSinglePropertyService(
        userDetail?.propertyId,
        true
      );
      if (res.status === 200) {
        setPropertyData(res?.data?.data);
      }
    } catch (error) {}
  };

  let myAllOrders = allOrders[0].orderItems

  const totalOrderCount = allOrders.reduce((acc, curr)=>{
    const xOrders = JSON.parse(curr.orderItems);
    return acc + xOrders.length
  }, 0)

  return (
    <div className="foodInvoice">
        <div className=" bg-white py-2 foodPdf" ref={targetRef}>
            <span className="text-black gstText" style={{ fontSize: "10px" }}>
              GSTIN No.: {propertyData?.gstNumber}
            </span>
            <div className="text-center text-black content">
              <span>{propertyData?.name}</span>
              <br />
              <span>{propertyData?.address}</span>
              <span>Contact No.:{propertyData?.ownerMobile}</span>
              <span>
                Room Service - <small>(Sale Bill)</small>
              </span>
            </div>
            <div className="borderedDiv">
              <p>
                Bill Number: - {allOrders[0]?.BookingHotel?.bookingCode}
                {/* <input
                  type="text"
                  className="noCenter"
                  style={{
                    borderWidth: textInputs.billNumber.length > 0 ? 0 : 1,
                  }}
                  value={textInputs.billNumber}
                  onChange={(e) =>
                    setTextInputs({ ...textInputs, billNumber: e.target.value })
                  }
                /> */}
              </p>
              <p>
                Date:{" "}
                <span>{moment(item?.createdAt).format("YYYY-MM-DD")}</span>
              </p>
            </div>
            <div className="borderedDiv">
              <p>
                Room Number: <span>{allOrders[0]?.roomNumber}</span>
              </p>
              <p>
                Booking ID: <span>{allOrders[0]?.BookingHotel?.id}</span>
              </p>
            </div>
            {allOrders?.map((mainItem, i) => {
              const mainOrderItem = StringToJSON(mainItem.orderItems)
             return (
              
              <div key={i + 1} style={{padding: '5px'}} className={((i + 1) % 1 === 0) ? 'page-break' : ''}>
                <div className="borderedDiv" style={{ borderTop: 'none' }}>
                  <p>
                    Order Number: <span>{mainItem.id}</span>
                  </p>
                </div>
                <div className="borderedDiv">
                  <p className="w-25">Item Name</p>
                  <p className="w-25 justify-content-end">Rate</p>
                  <p className="w-25 justify-content-center">Qty</p>
                  <p className="w-25 justify-content-center">Tax</p>
                  <p className="w-25 justify-content-end">Amount</p>
                </div>
                {mainOrderItem?.map((data, ind) => (
                  <div className="borderedDiv other" key={ind}>
                    <p className="w-25">{data?.name}</p>
                    <p className="w-25 justify-content-end">
                      {showRowPrice(data?.amountBeforeTax)}
                    </p>
                    <p className="w-25 justify-content-center">{data?.qty}</p>
                    <p className="w-25 justify-content-center">
                      {showRowPrice(data?.taxAmount * data?.qty)}
                    </p>
                    <p className="w-25 justify-content-end">
                      {showPrice(data?.qty * data?.price)}
                    </p>
                  </div>
                ))}
              </div>
            )})}

            <div className="borderedDiv flex-column p-1">
              <p className="justify-content-between w-100">
                Gross Amount: <span>{showRowPrice(totalGrossAmount)}</span>
              </p>
              <p className="justify-content-between w-100">
                SGST:
                <span>{showRowPrice(totalGrossAmount * 6 / 100)}</span>
              </p>
              <p className="justify-content-between w-100">
                CGST:
                <span>{showRowPrice(totalGrossAmount * 6 / 100)}</span>
              </p>
              <p className="justify-content-between w-100">
                Net Amount: <span>{showPrice(totalAmount)}</span>
              </p>
            </div>
            <div className="borderedDiv flex-column align-items-start">
              <p>
                Customer Name:{" "}
                {/* <input
                  type="text"
                  className="noCenter mw-100"
                  style={{ borderWidth: textInputs.name.length > 0 ? 0 : 1 }}
                  value={textInputs.name}
                  onChange={(e) =>
                    setTextInputs({ ...textInputs, name: e.target.value })
                  }
                /> */}
                {booking?.User?.name}
              </p>
              <p>
                Customer GST:
                <input
                  type="text"
                  className="noCenter mw-100"
                  style={{ borderWidth: textInputs.gst.length > 0 ? 0 : 1 }}
                  value={textInputs.gst}
                  onChange={(e) =>
                    setTextInputs({ ...textInputs, gst: e.target.value })
                  }
                />
              </p>
            </div>
          </div>
      </div>
  );
};

export default FoodInvoiceBill;
